import { Address } from '../types/index';

export interface CSVExportData {
  businessName: string;
  address: string;
  latitude: number | null;
  longitude: number | null;
  isSelected: boolean;
  isOnRoute: boolean;
}

export const convertAddressesToCSV = (addresses: Address[]): string => {
  if (addresses.length === 0) {
    return '';
  }

  // CSV headers
  const headers = ['Business Name', 'Address', 'Latitude', 'Longitude', 'Selected', 'On Route'];
  
  // Convert addresses to CSV rows
  const csvRows = addresses.map(address => {
    const row = [
      `"${address.businessName?.replace(/"/g, '""') || ''}"`, // Escape quotes in business name
      `"${address.address?.replace(/"/g, '""') || ''}"`,     // Escape quotes in address
      address.latitude?.toString() || '',
      address.longitude?.toString() || '',
      address.isSelected ? 'Yes' : 'No',
      address.isOnRoute ? 'Yes' : 'No'
    ];
    return row.join(',');
  });

  // Combine headers and rows
  const csvContent = [headers.join(','), ...csvRows].join('\n');
  
  return csvContent;
};

export const downloadCSV = (addresses: Address[], filename: string = 'addresses.csv') => {
  const csvContent = convertAddressesToCSV(addresses);
  
  if (!csvContent) {
    alert('No addresses to export');
    return;
  }
  
  // Create blob with CSV content
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
  // Create download link
  const link = document.createElement('a');
  if (link.download !== undefined) {
    // Create object URL for the blob
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    
    // Add to DOM, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up object URL
    URL.revokeObjectURL(url);
  } else {
    // Fallback for older browsers
    const csvData = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
    window.open(csvData);
  }
};

export const downloadGeocodedAddresses = (addresses: Address[], filename: string = 'geocoded_addresses.csv') => {
  // Filter addresses that have coordinates
  const geocodedAddresses = addresses.filter(addr => addr.latitude && addr.longitude);
  
  if (geocodedAddresses.length === 0) {
    alert('No geocoded addresses to export');
    return;
  }
  
  downloadCSV(geocodedAddresses, filename);
};

export const downloadAllAddresses = (addresses: Address[], filename: string = 'all_addresses.csv') => {
  downloadCSV(addresses, filename);
}; 